import { action, observable, makeObservable } from 'mobx';
import axios from 'axios';
import { errorAlert } from '../utils/alerts';

const { REACT_APP_API_URL } = process.env;

class PasswordStore {
  newPasswordErrors = {};

  constructor(profileStore) {
    makeObservable(this, {
      newPasswordErrors: observable,
      savePasswordChange: action
    });

    this.profileStore = profileStore;
  }

  async savePasswordChange(values, t) {
    const { currentPassword, newPassword } = values;

    const authToken = await this.profileStore.getAuthToken();

    const dataToSave = {
      login: this.profileStore.profileData.email,
      old_password: currentPassword,
      new_password: newPassword,
      realm: this.profileStore.connection,
    };

    try {
      await axios.patch(`${REACT_APP_API_URL}/me/changePassword`, dataToSave, {
        headers: { Authorization: `Bearer ${authToken}` },
      });

      this.profileStore.saveProfileSuccess(t('passwordPage.updateSuccess'));
    } catch (error) {
      errorAlert(t('passwordPage.updateError'));
    }
  }

  validatePassword(values, t) {
    const errors = {};

    if (!values.currentPassword) {
      errors.currentPassword = t('currentPassword.validation');
    }

    this.newPasswordErrors = {};

    if (!values.newPassword) {
      errors.newPassword = t('newPassword.validation');
    } else {
      const newPassword = values.newPassword || '';

      if (newPassword.length < 8) {
        errors.newPassword = t('passwordStrength.invalid');
        this.newPasswordErrors.length = true;
      }

      let validAdditional = 0;

      const specialChars = ['!', '@', '#', '$', '%', '^', '&', '*'];
      const hasSpecial = specialChars.some(substring => newPassword.includes(substring));

      if (!hasSpecial) {
        this.newPasswordErrors.specialCharacters = true;
      } else {
        validAdditional += 1;
      }

      if (!newPassword.match('.*[A-Z].*')) {
        this.newPasswordErrors.upperCase = true;
      } else {
        validAdditional += 1;
      }

      if (!newPassword.match('.*[a-z].*')) {
        this.newPasswordErrors.lowerCase = true;
      } else {
        validAdditional += 1;
      }

      if (!newPassword.match('.*[0-9].*')) {
        this.newPasswordErrors.numbers = true;
      } else {
        validAdditional += 1;
      }

      if (validAdditional > 2) {
        this.newPasswordErrors.strength = false;
      } else {
        this.newPasswordErrors.strength = true;
        errors.newPassword = t('passwordStrength.invalid');
      }
    }

    if (!values.newPasswordConfirm) {
      errors.newPasswordConfirm = t('newPasswordConfirm.validation');
    } else {
      if (values.newPassword !== values.newPasswordConfirm) {
        errors.newPasswordConfirm = t('newPassword.notSamePassword');
      }
    }

    return errors;
  }
}

export default PasswordStore;
